import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import "./stops.css";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ArrowDropDown, ArrowDropUp, Schedule } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import Pagination from "../../components/pagination/Pagination";
import { getSortedData } from "../organization/utils";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ListItemIcon from "@mui/material/ListItemIcon";
import { stop_base_url } from "./utils";
import axios from "axios";
import { usePermission } from "../../hooks/usePermission";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  styled,
} from "@mui/material";
import { useNavigate } from "react-router";
function createData(index, id, stopId, name, routes) {
  return { index, id, stopId, name, routes };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(32, 168, 224, 1)",
    color: " white",
    fontSize: 20,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 24,
  },
}));

// Define columns for the table
const columns = [
  { label: "Stop ID", sortable: true, id: "id" },
  { label: "Stop Name", sortable: true, id: "name" },
  { label: "Routes", sortable: true, id: "routeName" },
  { label: "Actions", sortable: false, id: "actions" },
];

// Convert rows to the required format
const getRows = (rows) =>
  rows.map((item, index) => {
    if (!item) {
      console.error("getRows: item is null", { item, index });
      return null;
    }
    return {
      index,
      ...item,
    };
  });

function StopsTable({
  stopsData,
  setStopsData,
  filteredStopsData,
  onAddUpdateDialogOpen,
  onSelectedStopDataChange,
  updatedStopsData,
  searchInput,
  selectedRouteFilter,
}) {
  const theme = useTheme();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedStopId, setSelectedStopId] = useState(null);
  // const [organizationSchedules,setOrganizationSchedules]=useState([]);
  const [stopSchedulesData, setStopSchedulesData] = useState([]);
  const [localStopsData, setLocalStopsData] = useState([]); // New local state for immediate UI updates

  const navigate = useNavigate();

  const { hasPermission } = usePermission();

  useEffect(() => {
    setLocalStopsData(filteredStopsData);
  }, [filteredStopsData]);

  // Reset to first page when data changes
  useEffect(() => {
    setCurrentPage(1);
  }, [filteredStopsData, itemsPerPage]);

  // Handle rows per page change
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setItemsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset to first page when changing rows per page
  };

  // Handle sorting of table columns
  const handleColumnSort = (id) => {
    const newOrder = order === "asc" ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(id);
  };
  const open = Boolean(anchorEl);

  // handling icon button open
  const handleOpenMenu = (event, id) => {
    event.preventDefault();
    setSelectedStopId(id);
    console.log("Selected Stop ID:", id);
    const selectedRowData = updatedStopsData.find((stop) => stop.id === id);
    onSelectedStopDataChange(selectedRowData);
    setAnchorEl(event.currentTarget);
  };

  // handling delete modal open
  const openDeleteModal = () => {
    // setSelectedStopId(selectedStopId);
    setIsDeleteModalOpen(true);
  };

  // handling delete modal dailog close
  const handleDeleteDialogClose = () => {
    setSelectedStopId(null);
    setIsDeleteModalOpen(false);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleCloseUpdateModal = () => {
    setIsUpdateModalOpen(false);
  };

  // Handle opening update modal for updating the perticular row data

  const handleOpenUpdate = (id) => {
    navigate(`/stops/${selectedStopId}`);
  };

  const handleDelete = () => {
    if (selectedStopId) {
      // Check if selectedStopId is truthy before proceeding
      axios
        .delete(stop_base_url, {
          data: {
            id: selectedStopId,
          },
          withCredentials: true,
        })
        .then(() => {
          const updatedStops = stopsData.filter(
            (stop) => stop.id !== selectedStopId
          );
          handleDeleteDialogClose();
          setLocalStopsData(updatedStops || []);
          setSelectedStopId(null);
          setAnchorEl(null);
        })
        .catch((error) => {
          console.error("Error deleting stop:", error);
        });
    }
  };

  const stopScheduleDetails = () => {
    const id = selectedStopId;
    console.log("this is schedules id", id);
    navigate(`/Stops/Schedule/Details`, { state: { id } }); // Navigate with the id
  };

  const stopDetails = () => {
    const id = selectedStopId;
    console.log("stop details id", id);
    const selectedStopData = localStopsData.find((stop) => stop.id === id);
    console.log("selectedStopData", selectedStopData);

    navigate(`stop/track`, {
      state: {
        selectedStopData: selectedStopData,
        localStopsData: localStopsData,
      },
    });// Navigate with the selected and all stops data
  };

  // const stopDetailsUserView = () => {
  //   const id = selectedStopId;
  //   console.log("stop details id", id);
  //   const selectedStopData = localStopsData.find((stop) => stop.id === id);
  //   console.log("selectedStopData", selectedStopData);
  //   navigate(`/track/screen`, { state: { selectedStopData: selectedStopData } });  // to show only maps and table on the screen
  // };

  const styles = {
    header: { backgroundColor: theme.palette.primary.main, color: "white" },
  };

  // calculating pagination
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const totalCount = localStopsData?.length || 0;
  const totalPages = Math.ceil(totalCount / itemsPerPage) || 1;

  // handle pagination page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const sortedData = localStopsData.sort((a, b) =>
    getSortedData(a, b, orderBy, order)
  );
  const currentData = sortedData?.slice(startIndex, endIndex);
  useEffect(() => {
    console.log("currentData", currentData);
  }, [currentData]);
  return (
    <>
      <TableContainer component={Paper}>
        {currentData.length === 0 && (
          <div style={{ padding: "16px", textAlign: "center", color: "gray" }}>
            {localStopsData.length === 0 &&
              searchInput &&
              "No stops found with the entered search text."}
            {localStopsData.length === 0 &&
              selectedRouteFilter.name &&
              "No stops found with the selected route."}
          </div>
        )}
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <StyledTableCell
                  align="left"
                  // style={styles.header}
                  key={column.id}
                  onClick={() => handleColumnSort(column.id)}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px", // Optional gap between text and icon
                    }}
                  >
                    {column.label}{" "}
                    {column.sortable &&
                      (orderBy === column.id ? (
                        order === "asc" ? (
                          <ArrowDropUp
                            style={{
                              verticalAlign: "middle",
                              cursor: "pointer",
                              color: "rgba(24, 48, 89, 1)",
                            }}
                          />
                        ) : (
                          <ArrowDropDown
                            style={{
                              verticalAlign: "middle",
                              cursor: "pointer",
                              color: "rgba(24, 48, 89, 1)",
                            }}
                          />
                        )
                      ) : (
                        <ArrowDropUp
                          style={{
                            verticalAlign: "middle",
                            cursor: "pointer",
                            color: "rgba(24, 48, 89, 1)",
                          }}
                        />
                      ))}
                  </div>
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={{ padding: "0px" }}>
            {getRows(currentData).map((row) => (
              <TableRow
                key={row.index}
                // className="MuiTableRow-root"
                style={{ color: "black" }}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell style={{ fontWeight: 600 }}>{row.stopId}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>
                  {row.routes
                    ?.map((route) => {
                      console.log("route", route);
                      return route.name;
                    })
                    .join(", ")}
                </TableCell>

                <TableCell>
                  <IconButton
                    aria-label="action-btn"
                    id="action-btn"
                    onClick={(e) => handleOpenMenu(e, row.id)}
                  >
                    <MoreHorizIcon />
                  </IconButton>
                  {anchorEl && (
                    <Menu
                      id="action-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleCloseMenu}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                      MenuListProps={{
                        "aria-labelledby": "action-btn",
                      }}
                      PaperProps={{
                        style: {
                          backgroundColor: "rgba(255, 255, 255, 1)",
                          borderRadius: "8px",
                          boxShadow: "none",
                          border: '1px solid rgba(200, 203, 208, 1)'
                        },
                      }}
                    >
                      {hasPermission("/api/stop", "PUT") && (
                        <MenuItem
                          onClick={() => {
                            console.log("this is row", row);
                            handleOpenUpdate(row.id);
                          }}
                          sx={{
                            "&:hover": {
                              backgroundColor: "rgba(32, 168, 224, 1)", color: "rgba(255, 255, 255, 1)"  // Light blue hover effect
                            },
                          }}
                        >
                          <ListItemIcon>
                            <svg
                              width="18"
                              height="19"
                              viewBox="0 0 18 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.15659 3.18652H2.59035C2.16857 3.18652 1.76405 3.35408 1.4658 3.65233C1.16755 3.95058 1 4.35509 1 4.77688V15.9093C1 16.3311 1.16755 16.7356 1.4658 17.0339C1.76405 17.3321 2.16857 17.4997 2.59035 17.4997H13.7228C14.1446 17.4997 14.5491 17.3321 14.8474 17.0339C15.1456 16.7356 15.3132 16.3311 15.3132 15.9093V10.3431"
                                stroke="#1F242E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14.1189 1.99406C14.4352 1.67772 14.8643 1.5 15.3116 1.5C15.759 1.5 16.1881 1.67772 16.5044 1.99406C16.8208 2.3104 16.9985 2.73945 16.9985 3.18682C16.9985 3.6342 16.8208 4.06325 16.5044 4.37959L8.95024 11.9338L5.76953 12.7289L6.56471 9.54824L14.1189 1.99406Z"
                                stroke="#1F242E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </ListItemIcon>
                          Update
                        </MenuItem>
                      )
                      }
                      <MenuItem onClick={() => stopDetails(row.id)}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(32, 168, 224, 1)", color: "rgba(255, 255, 255, 1)"  // Light blue hover effect
                          },
                        }}>
                        <ListItemIcon>
                          <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1408_4150)">
                              <path
                                d="M8 16.5C8 16.5 14 10.814 14 6.5C14 4.9087 13.3679 3.38258 12.2426 2.25736C11.1174 1.13214 9.5913 0.5 8 0.5C6.4087 0.5 4.88258 1.13214 3.75736 2.25736C2.63214 3.38258 2 4.9087 2 6.5C2 10.814 8 16.5 8 16.5ZM8 9.5C7.20435 9.5 6.44129 9.18393 5.87868 8.62132C5.31607 8.05871 5 7.29565 5 6.5C5 5.70435 5.31607 4.94129 5.87868 4.37868C6.44129 3.81607 7.20435 3.5 8 3.5C8.79565 3.5 9.55871 3.81607 10.1213 4.37868C10.6839 4.94129 11 5.70435 11 6.5C11 7.29565 10.6839 8.05871 10.1213 8.62132C9.55871 9.18393 8.79565 9.5 8 9.5Z"
                                fill="#1F242E"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1408_4150">
                                <rect
                                  width="16"
                                  height="16"
                                  fill="white"
                                  transform="translate(0 0.5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </ListItemIcon>
                        Track
                      </MenuItem>

                      <MenuItem onClick={() => stopScheduleDetails(row.id)}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(32, 168, 224, 1)", color: "rgba(255, 255, 255, 1)"  // Light blue hover effect
                          },
                        }}>
                        <ListItemIcon>
                          <svg
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12.4378 9.0794C13.1421 9.07915 13.8307 9.28777 14.4165 9.67889C15.0022 10.07 15.4588 10.6261 15.7286 11.2767C15.9983 11.9274 16.069 12.6434 15.9317 13.3342C15.7945 14.025 15.4554 14.6597 14.9575 15.1578C14.4595 15.6559 13.8251 15.9952 13.1343 16.1327C12.4435 16.2702 11.7274 16.1998 11.0767 15.9303C10.4259 15.6608 9.86973 15.2044 9.47839 14.6188C9.08706 14.0332 8.87818 13.3446 8.87818 12.6403C8.87818 11.6961 9.25317 10.7906 9.92069 10.1228C10.5882 9.45507 11.4936 9.07975 12.4378 9.0794ZM9.32085 1.31962C9.32085 1.02928 9.60859 0.798828 9.96403 0.798828C10.3195 0.798828 10.6072 1.03579 10.6072 1.32613V3.77385C10.6072 4.06549 10.3195 4.30115 9.96403 4.30115C9.60859 4.30115 9.32085 4.06549 9.32085 3.77385V1.31962ZM3.5583 1.31962C3.5583 1.02928 3.84604 0.798828 4.20148 0.798828C4.55692 0.798828 4.84596 1.03579 4.84596 1.32613V3.77385C4.84596 4.06549 4.55692 4.30766 4.20148 4.30766C3.84604 4.30766 3.5583 4.072 3.5583 3.78036V1.31962ZM6.24949 10.9035H7.81186C7.60535 11.4592 7.50039 12.0475 7.50199 12.6403C7.50199 12.7536 7.50199 12.8669 7.51371 12.9788H6.24949C6.18502 12.9785 6.12329 12.9527 6.07771 12.9071C6.03212 12.8616 6.00636 12.7998 6.00602 12.7354V11.1469C6.00636 11.0825 6.03212 11.0207 6.07771 10.9752C6.12329 10.9296 6.18502 10.9038 6.24949 10.9035ZM10.1033 7.52484H12.0133C12.0672 7.52528 12.1193 7.54334 12.1619 7.57626C12.2045 7.60919 12.2351 7.65515 12.249 7.70712C11.4037 7.73845 10.5808 7.98733 9.85987 8.42972V7.76701C9.86022 7.70266 9.88602 7.64107 9.93164 7.59569C9.97727 7.55031 10.039 7.52484 10.1033 7.52484ZM6.24949 7.52484H8.16079C8.22514 7.52484 8.28687 7.55031 8.33249 7.59569C8.37812 7.64107 8.40392 7.70266 8.40426 7.76701V9.35672C8.40359 9.42109 8.37772 9.48262 8.3322 9.52813C8.28669 9.57365 8.22515 9.59952 8.16079 9.60019H6.24949C6.18502 9.59985 6.12329 9.57409 6.07771 9.52851C6.03212 9.48292 6.00636 9.42119 6.00602 9.35672V7.76701C6.0067 7.70277 6.03261 7.64137 6.07816 7.59607C6.12371 7.55076 6.18525 7.52518 6.24949 7.52484ZM2.39824 7.52484H4.30954C4.34173 7.52433 4.37371 7.5302 4.40361 7.54212C4.43352 7.55404 4.46077 7.57178 4.48377 7.5943C4.50678 7.61682 4.52509 7.64368 4.53764 7.67333C4.5502 7.70297 4.55675 7.73482 4.55692 7.76701V9.35672C4.55624 9.42109 4.53037 9.48262 4.48486 9.52813C4.43935 9.57365 4.37781 9.59952 4.31345 9.60019H2.39954C2.33497 9.60019 2.27304 9.57454 2.22738 9.52888C2.18173 9.48322 2.15607 9.4213 2.15607 9.35672V7.76701C2.15642 7.70266 2.18222 7.64107 2.22784 7.59569C2.27347 7.55031 2.3352 7.52484 2.39954 7.52484H2.39824ZM2.39824 10.9035H4.30954C4.34184 10.903 4.37392 10.9089 4.40392 10.9209C4.43391 10.9329 4.46121 10.9507 4.48423 10.9734C4.50726 10.996 4.52554 11.0231 4.53802 11.0529C4.5505 11.0827 4.55692 11.1146 4.55692 11.1469V12.7354C4.55623 12.8004 4.52983 12.8625 4.48347 12.9081C4.43712 12.9538 4.37458 12.9792 4.30954 12.9788H2.39954C2.33497 12.9788 2.27304 12.9532 2.22738 12.9075C2.18173 12.8619 2.15607 12.7999 2.15607 12.7354V11.1469C2.15607 11.0824 2.18173 11.0204 2.22738 10.9748C2.27304 10.9291 2.33497 10.9035 2.39954 10.9035H2.39824ZM8.31963 15.364H1.33322C0.980054 15.3627 0.641739 15.2218 0.392008 14.972C0.142276 14.7223 0.00137155 14.384 0 14.0308V3.46658C0.00171145 3.11351 0.142725 2.7754 0.392383 2.52574C0.642042 2.27608 0.980159 2.13507 1.33322 2.13335H2.56229V3.77385C2.56347 3.99316 2.61392 4.20941 2.70992 4.4066C2.80593 4.60379 2.94503 4.77688 3.11693 4.91308C3.42402 5.16158 3.80709 5.29716 4.20213 5.29716C4.59717 5.29716 4.98024 5.16158 5.28733 4.91308C5.45924 4.77688 5.59834 4.60379 5.69434 4.4066C5.79034 4.20941 5.8408 3.99316 5.84197 3.77385V2.13335H8.32484V3.77385C8.32577 3.99307 8.37598 4.20929 8.47176 4.40648C8.56754 4.60368 8.70644 4.77682 8.87818 4.91308C9.18548 5.16168 9.56877 5.29731 9.96403 5.29731C10.3593 5.29731 10.7426 5.16168 11.0499 4.91308C11.2214 4.77663 11.3602 4.60345 11.4559 4.4063C11.5517 4.20914 11.602 3.99302 11.6032 3.77385V2.13335H12.8896C13.2427 2.13473 13.5811 2.27563 13.8308 2.52536C14.0805 2.77509 14.2214 3.11341 14.2228 3.46658V8.03522C14.037 7.96315 13.847 7.90229 13.6538 7.85294V5.99241H0.568964V13.747C0.5717 14.0235 0.683207 14.2878 0.879356 14.4828C1.07551 14.6777 1.34052 14.7876 1.61706 14.7886H7.99674C8.09322 14.9849 8.20193 15.1749 8.32224 15.3575L8.31963 15.364ZM11.9443 10.8475H12.3792C12.4179 10.8475 12.455 10.8629 12.4823 10.8902C12.5097 10.9175 12.525 10.9546 12.525 10.9933V12.6703H14.0614C14.0998 12.6703 14.1367 12.6854 14.164 12.7125C14.1913 12.7396 14.2068 12.7763 14.2072 12.8148V13.2509C14.2068 13.2894 14.1913 13.3261 14.164 13.3532C14.1367 13.3803 14.0998 13.3955 14.0614 13.3955H11.7998V10.9933C11.7998 10.9549 11.815 10.918 11.8421 10.8907C11.8691 10.8633 11.9059 10.8478 11.9443 10.8475ZM12.4378 9.88793C12.9822 9.88767 13.5145 10.0489 13.9673 10.3512C14.4201 10.6534 14.7731 11.0832 14.9816 11.5861C15.1901 12.089 15.2448 12.6425 15.1387 13.1765C15.0327 13.7105 14.7707 14.201 14.3858 14.5861C14.0009 14.9711 13.5105 15.2334 12.9765 15.3397C12.4426 15.446 11.8891 15.3916 11.3861 15.1833C10.8831 14.975 10.4532 14.6222 10.1507 14.1696C9.84817 13.7169 9.68671 13.1847 9.68671 12.6403C9.68654 12.2789 9.75757 11.921 9.89575 11.5871C10.0339 11.2532 10.2365 10.9498 10.492 10.6942C10.7475 10.4386 11.0508 10.2358 11.3847 10.0975C11.7186 9.95913 12.0764 9.88793 12.4378 9.88793Z"
                              fill="#1F242E"
                            />
                          </svg>
                        </ListItemIcon>
                        Schedules
                      </MenuItem>

                      {
                        hasPermission("/api/stop", "DELETE") &&
                        <MenuItem onClick={() => openDeleteModal(row.id)}
                          sx={{
                            "&:hover": {
                              backgroundColor: "rgba(32, 168, 224, 1)", color: "rgba(255, 255, 255, 1)"  // Light blue hover effect
                            },
                          }}>
                          <ListItemIcon>
                            <svg
                              width="18"
                              height="19"
                              viewBox="0 0 18 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 4.40039H2.77778H17"
                                stroke="#1F242E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M15.2218 4.4V16.3C15.2218 16.7509 15.0345 17.1833 14.7011 17.5021C14.3677 17.8209 13.9155 18 13.444 18H4.55512C4.08363 18 3.63144 17.8209 3.29804 17.5021C2.96464 17.1833 2.77734 16.7509 2.77734 16.3V4.4M5.44401 4.4V2.7C5.44401 2.24913 5.63131 1.81673 5.96471 1.49792C6.29811 1.17911 6.75029 1 7.22179 1H10.7773C11.2488 1 11.701 1.17911 12.0344 1.49792C12.3678 1.81673 12.5551 2.24913 12.5551 2.7V4.4"
                                stroke="#1F242E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M7.22266 8.65039V13.7504"
                                stroke="#1F242E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.7773 8.65039V13.7504"
                                stroke="#1F242E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </ListItemIcon>
                          Delete
                        </MenuItem>
                      }
                    </Menu>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
      <Dialog
        open={isDeleteModalOpen}
        onClose={handleDeleteDialogClose}
        PaperProps={{
          style: {
            backgroundColor: "white",
            width: "594px",
            maxWidth: "600px",
            height: {
              xs: "auto",
              md: "294px"
            }
          },
        }}
      >
        <DialogTitle style={{ fontWeight: "bolder", marginTop: "5px" }}>
          <span
            style={{
              color: "#EE3B2B",
              height: "38px",
              width: "514px",
              fontSize: "32px",
              fontWeight: "600",
            }}
          >
            {" "}
            Delete Stop!
          </span>

          {/* <DialogContentText
            style={{ color: "#1F242E", fontSize: "24px", fontWeight: "400" }}
          >
          </DialogContentText> */}
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: "rgba(58, 58, 58, 1)", fontSize: "24px", fontWeight: "400", marginTop: "-6px" }}>
            Do you want to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",

            justifyContent: "space-evenly",
          }}
        >
          <button
            className="customButton_add"
            onClick={handleDeleteDialogClose}
            color="primary"
            style={{
              padding: "10px 40px", fontWeight: "bold", textTransform: "none", background: "#F2F2F3", marginRight: "50px"
            }}
          >
            Cancel
          </button>
          <button
            className="customButton_add"
            color="primary"
            variant="contained"
            autoFocus
            onClick={handleDelete}
            style={{
              padding: "10px 40px", fontWeight: "bold", textTransform: "none", background: "#EE3B2B", color: "white"
            }}
          >
            Delete
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default StopsTable;

